import { User_user } from 'main/gql/user'
import { emailInputIsValid } from 'main/util/email'
import { phoneInputIsValid } from 'main/util/phone'
import { IParams, IValidation } from './types'

export function initialParams(user: User_user | null): IParams {
  return {
    email: user ? user.email : '',
    firstName: (user && user.firstName) || '',
    lastName: (user && user.lastName) || '',
    message: '',
    phone: (user && user.phone) || '',
  }
}

export function validate(params: IParams) {
  const hints: IValidation = {}

  if (!params.email.trim() || !emailInputIsValid(params.email.trim())) {
    hints.email = 'Please enter a valid email'
  }
  if (!params.firstName.trim()) {
    hints.firstName = 'Please enter a first name'
  }
  if (!params.lastName.trim()) {
    hints.lastName = 'Please enter a last name'
  }
  if (!params.phone.trim() || !phoneInputIsValid(params.phone.trim())) {
    hints.phone = 'Please enter a valid phone number'
  }

  return Object.keys(hints).length ? hints : null
}
